<div class="row">
  <div class="col">
    <span>Inicio > inicio</span>
  </div>
</div>
